interface Props {
  error: string;
  issues?: string[];
  raw?: unknown;
}

export function ErrorPanel({ error, issues, raw }: Props) {
  return (
    <div className="min-h-screen flex items-center justify-center p-8">
      <div className="max-w-2xl w-full rounded bg-red-950/80 ring-1 ring-red-700/60 p-6 text-red-100 font-mono text-sm">
        <div className="text-base font-bold mb-3">config error</div>
        <div className="mb-3">{error}</div>
        {issues && issues.length > 0 && (
          <ul className="list-disc list-inside space-y-1 mb-3">
            {issues.map((i, idx) => (
              <li key={idx}>{i}</li>
            ))}
          </ul>
        )}
        {raw !== undefined && (
          <details>
            <summary className="cursor-pointer text-red-300">parsed yaml (pre-validation)</summary>
            <pre className="mt-2 whitespace-pre-wrap break-all">{JSON.stringify(raw, null, 2)}</pre>
          </details>
        )}
        <div className="mt-4 text-red-300 text-xs">
          edit <code>public/config.yaml</code> and reload.
        </div>
      </div>
    </div>
  );
}
